import { createSelector } from '@reduxjs/toolkit';

//📌 Selector for get all floors from current profile.
export const selectFloors = createSelector(
	[(state) => state.Floors.data, (state) => state.Auth.selectedProfile.orgID],
	(floorsData, orgID) => floorsData[orgID] || []
);

//📌 Selector for get floor by floorID.
export const selectFloorsByFloorID = createSelector(
	[(state) => state.Floors.data, (state) => state.Auth.selectedProfile.orgID, (_, floorID) => floorID],
	(floorsData, orgID, floorID) => (floorsData[orgID] || []).find((floor) => floor.floorID === floorID) || null
);

//📌 Selector for get all floors by siteID.
// Returns the *list* of floors at the given site (plural — matches the name).
// Previously returned `.find(...)` (a single floor) despite the plural name;
// audited callers and found none relying on the single-element behaviour.
export const selectFloorsBySiteID = createSelector(
	[(state) => state.Floors.data, (state) => state.Auth.selectedProfile.orgID, (_, siteID) => siteID],
	(floorsData, orgID, siteID) => (floorsData[orgID] || []).filter((floor) => floor.siteID === siteID)
);

//📌 Selector for get all floors by name.
export const selectFloorsByName = createSelector(
	[(state) => state.Floors.data, (state) => state.Auth.selectedProfile.orgID, (_, name) => name],
	(floorsData, orgID, name) =>
		(floorsData[orgID] || []).filter((floor) => floor.name.toLowerCase().includes(name.toLowerCase())) || []
);

//📌 Selector for floor plan alert visibility.
export const selectFloorPlanAlertVisible = createSelector(
	[(state) => state.Floors.floorPlanAlert],
	(floorPlanAlert) => floorPlanAlert.visible
);
